import React, {Component} from "react";
import config from 'react-global-configuration';
import {NavLink} from "react-router-dom";
import {Collapse} from 'react-bootstrap';
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.jsx";

import logo from "assets/img/Innoviti_logo_2025.png";
import logoMini from "assets/img/Innoviti_mini1_2025.png";
import {Scrollbars} from "react-custom-scrollbars";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      componentMenuOpen: []
    };
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  onToggleNav(i,e) {
    e.preventDefault();
    this.setState({
      componentMenuOpen: {...this.state.componentMenuOpen, [i]:!this.state.componentMenuOpen[i] },
    });
  }
  GetShortName(val){
    //alert(val);
    let acronym = val.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'');
    return acronym;

  }
  render() {
    const sidebarBackground = {
      backgroundImage: "url(" + this.props.image + ")"
    };
    return (

      <div
        id="sidebar"
        className="sidebar"
        data-color={this.props.color}
        data-image={this.props.image}
      >

        <div className="logo">
          <a
            href="/"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="logo_image" />
            </div>
            <div className="logo-img-mini">
              <img src={logoMini} alt="logo_image" />
            </div>
          </a>

        </div>
        <Scrollbars>
          {this.props.hasImage ? (
            <div className="sidebar-background"  />
          ) : (
            null
          )}
        <div className="sidebar-wrapper">

          <ul className="nav">
            {this.state.width <= 991 ? <AdminNavbarLinks /> : null}
            {this.props.routes.map((prop, key) => {
              if (!prop.redirect)
                return (
                  <li
                    className={
                       this.activeRoute(prop.layout + prop.path)
                    }
                    key={key}
                  >
                    {prop.isDrop===true?
                        <React.Fragment>
                    <NavLink to="#" onClick={this.onToggleNav.bind(this, key)}
                             data-toggle="collapse"
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className={prop.icon} />
                      <p>{prop.name} <b className="caret"></b></p>
                    </NavLink>

                    <Collapse in={this.state.componentMenuOpen[key]}>
                      <div>
                        <ul className="nav dropdown">
                          {prop.submenus.map((submenu, key) => {
                            if (!submenu.redirect)
                              return (
                          <li className={
                            this.activeRoute(submenu.layout + submenu.path)
                          } key={key}>
                            {submenu.layout=='newtab'?
                                <a className="nav-link" rel="noopener noreferrer" href={config.get('LOG_URL')} target="_blank">
                                  <span className="sidebar-mini">{this.GetShortName(submenu.name)}</span>
                                  <span className="sidebar-normal">{submenu.name}</span>
                                  <span className="clearfix"></span>
                                </a>

                                :
                            <NavLink
                                to={submenu.layout + submenu.path}
                                className="nav-link"
                                activeClassName="active"
                            >
                            <span className="sidebar-mini">{this.GetShortName(submenu.name)}</span>
                            <span className="sidebar-normal">{submenu.name}</span>
                            <span className="clearfix"></span>
                            </NavLink> }
                          </li>
                              );
                            return null;
                          })}

                        </ul>
                      </div>
                    </Collapse>
                    </React.Fragment>
                        : <NavLink
                                   to={prop.layout + prop.path}
                                   className="nav-link"
                                   activeClassName="active"
                        >
                          <i className={prop.icon} />
                          <p>{prop.name}</p>
                        </NavLink> }
                  </li>
                );
              return null;
            })}
          </ul>

        </div>
</Scrollbars>
      </div>

    );
  }
}

export default Sidebar;
